module.exports = __webpack_public_path__ + "img/lightbox_btn_02.b1d700c2.jpg";